import { render, staticRenderFns } from "./DecayRange.vue?vue&type=template&id=5c117b38&"
import script from "./DecayRange.vue?vue&type=script&lang=js&"
export * from "./DecayRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports